import { BaseApi } from '@/apis/BaseApi';
import { IReportContentCategory } from '@/models/application';

export class ReportContentCategoriesApi extends BaseApi {
  constructor() {
    super('reportcontentcategories');
  }

  async getById(id: string): Promise<IReportContentCategory> {
    return (await this.get<IReportContentCategory>(`/${id}`)).result;
  }

  async deleteById(id: string): Promise<boolean> {
    return (await this.delete<boolean>(`/${id}`)).result;
  }

  async create(
    category: IReportContentCategory
  ): Promise<IReportContentCategory> {
    return (await this.post<IReportContentCategory>('', category)).result;
  }

  async update(
    category: IReportContentCategory
  ): Promise<IReportContentCategory> {
    return (await this.put<IReportContentCategory>('', category)).result;
  }

  async getReportContentCategories(): Promise<IReportContentCategory[]> {
    return (await this.get<IReportContentCategory[]>()).result;
  }
}
